module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"typography":"Typography","selectFont":"Select your default typeface"},"es":{"typography":"Tipografía","selectFont":"Seleccione su tipografía por defecto"}}')
  delete Component.options._Ctor
}
